import axios from "axios";
import { toast } from "react-toastify";

//export const endPoint = apiConfig.base;
export const endPoint = process.env.REACT_APP_BASE_API;

axios.defaults.headers.common["Accept"] = "Application/json";

//The content-type \"application/json;charset=UTF-8\" is not supported. Supported MIME types are \"application/merge-patch+json\

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (!expectedError) {
    console.log("erro", error);
    toast.warn("An unexpected error occurred.");
  }

  return Promise.reject(error);
});

export function setJwt(jwt) {
  //axios.defaults.headers.common["x-auth-token"] = jwt;
  //axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;
}

const http = {
  axios,
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
  setJwt,
  endPoint,
};

export default http;
